import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import detailstyles from "./patientdetails.module.css";
import basestyles from "../../../shared/styles/basestyles.module.css";
import Input from "../../../shared/components/Input/Input";
import Textarea from "../../../shared/components/Textarea/Textarea";
import Button from "../../../shared/components/Button/Button";
import Header from "../../../shared/components/Header/Header";
import Backicon from "../../../shared/components/Backicon/Backicon";

const initialState = {
  FirstName: "",
  LastName: "",
  PhoneNumber: "",
  DateOfBirth: "",
  StreetAddress: "",
  StreetAddress2: "",
  City: "",
  State: "",
  ZipCode: "",
  Country: "",
  HomePhoneNumber: "",
  Hepetitis_MMR_B_vacc: "",
  Significant_Medical_History: "",
  List_any_medication_taken_regularly: "",
  Allergies: "",
  DoYouHaveMedicalInsurance: "",
  NameOfInsuranceCompany: "",
  InsuranceCompanyAddress: "",
  InsuranceCompanyAddress2: "",
  InsuranceCompanyCity: "",
  InsuranceCompanyAddressState: "",
  InsuranceCompanyZipcode: "",
  InsuranceCompanyCountry: "",
  PolicyNumber: "",
  PolicyExpiryDate: "",
  FirstNameError: "",
  LastNameError: "",
  PhoneNumberError: "",
  DateOfBirthError: "",
  StreetAddressError: "",
  StreetAddress2Error: "",
  CityError: "",
  StateError: "",
  ZipCodeError: "",
  CountryError: "",
  HomePhoneNumberError: "",
  Hepetitis_MMR_B_vaccError: "",
  Significant_Medical_HistoryError: "",
  List_any_medication_taken_regularlyError: "",
  AllergiesError: "",
  DoYouHaveMedicalInsuranceError: "",
  NameOfInsuranceCompanyError: "",
  InsuranceCompanyAddressError: "",
  InsuranceCompanyAddress2Error: "",
  InsuranceCompanyCityError: "",
  InsuranceCompanyAddressStateError: "",
  InsuranceCompanyZipcodeError: "",
  InsuranceCompanyCountryError: "",
  PolicyNumberError: "",
  PolicyExpiryDateError: "",
};
class PatientDetails extends Component {
  state = initialState;

  changeState = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  componentDidMount() {
    if (!localStorage.getItem("patient_personal_info")) {
      localStorage.setItem(
        "patient_personal_info",
        JSON.stringify({ existingPatientData: [] })
      );
    }
  }
  validate = () => {
    let FirstNameError = "";
    let LastNameError = "";
    let PhoneNumberError = "";

    let DateOfBirthError = "";
    let StreetAddressError = "";
    let StreetAddress2Error = "";
    let CityError = "";
    let StateError = "";
    let ZipCodeError = "";
    let CountryError = "";
    let HomePhoneNumberError = "";
    let Hepetitis_MMR_B_vaccError = "";
    let Significant_Medical_HistoryError = "";
    let List_any_medication_taken_regularlyError = "";
    let AllergiesError = "";
    let DoYouHaveMedicalInsuranceError = "";
    let NameOfInsuranceCompanyError = "";
    let InsuranceCompanyAddressError = "";
    let InsuranceCompanyAddress2Error = "";
    let InsuranceCompanyCityError = "";
    let InsuranceCompanyAddressStateError = "";
    let InsuranceCompanyZipcodeError = "";
    let InsuranceCompanyCountryError = "";
    let PolicyNumberError = "";
    let PolicyExpiryDateError = "";

    if (!this.state.FirstName) {
      FirstNameError = "Invalid Name";
    }

    if (!this.state.LastName) {
      LastNameError = "Invalid Name";
    }

    if (!this.state.PhoneNumber) {
      PhoneNumberError = "Invalid Phone Number";
    }

    if (!this.state.DateOfBirth) {
      DateOfBirthError = "Date of Birth Cannot Be Empty";
    }

    if (!this.state.StreetAddress) {
      StreetAddressError = "Invalid Address";
    }

    if (!this.state.StreetAddress2) {
      StreetAddress2Error = "Invalid Address";
    }

    if (!this.state.City) {
      CityError = "City Cannot Be Empty";
    }

    if (!this.state.State) {
      StateError = "State Cannot Be Empty";
    }

    if (!this.state.ZipCode) {
      ZipCodeError = "ZipCode Cannot Be Empty";
    }

    if (!this.state.Country) {
      CountryError = "Country Cannot Be Empty";
    }

    if (!this.state.HomePhoneNumber) {
      HomePhoneNumberError = "Invalid Phone Number";
    }

    if (!this.state.Hepetitis_MMR_B_vacc) {
      Hepetitis_MMR_B_vaccError = "This Feild Cannot Be Empty";
    }

    if (!this.state.Significant_Medical_History) {
      Significant_Medical_HistoryError = "History Cannot be Empty";
    }

    if (!this.state.List_any_medication_taken_regularly) {
      List_any_medication_taken_regularlyError =
        "Please Enter Your Medications";
    }

    if (!this.state.Allergies) {
      AllergiesError = "Allergies Cannot be empty";
    }

    if (!this.state.DoYouHaveMedicalInsurance) {
      DoYouHaveMedicalInsuranceError = "This Feild Cannot Be empty";
    }

    if (!this.state.NameOfInsuranceCompany) {
      NameOfInsuranceCompanyError = "Enter Company Name";
    }

    if (!this.state.InsuranceCompanyAddress) {
      InsuranceCompanyAddressError = "Enter Valid Address";
    }

    if (!this.state.InsuranceCompanyAddress2) {
      InsuranceCompanyAddress2Error = "Enter Valid Address";
    }

    if (!this.state.InsuranceCompanyCity) {
      InsuranceCompanyCityError = "Enter Valid City";
    }

    if (!this.state.InsuranceCompanyAddressState) {
      InsuranceCompanyAddressStateError = "Enter Valid State/Province";
    }

    if (!this.state.InsuranceCompanyZipcode) {
      InsuranceCompanyZipcodeError = "Enter valid ZipCode";
    }

    if (!this.state.InsuranceCompanyCountry) {
      InsuranceCompanyCountryError = "Enter Valid Country Name";
    }

    if (!this.state.PolicyNumber) {
      PolicyNumberError = "Enter Valid Policy Number";
    }

    if (!this.state.PolicyExpiryDate) {
      PolicyExpiryDateError = "Enter valid Date";
    }

    if (
      FirstNameError ||
      LastNameError ||
      PhoneNumberError ||
      DateOfBirthError ||
      StreetAddressError ||
      StreetAddress2Error ||
      CityError ||
      StateError ||
      ZipCodeError ||
      CountryError ||
      HomePhoneNumberError ||
      Hepetitis_MMR_B_vaccError ||
      Significant_Medical_HistoryError ||
      List_any_medication_taken_regularlyError ||
      AllergiesError ||
      DoYouHaveMedicalInsuranceError ||
      NameOfInsuranceCompanyError ||
      InsuranceCompanyAddressError ||
      InsuranceCompanyAddress2Error ||
      InsuranceCompanyCityError ||
      InsuranceCompanyAddressStateError ||
      InsuranceCompanyZipcodeError ||
      InsuranceCompanyCountryError ||
      PolicyNumberError ||
      PolicyExpiryDateError
    ) {
      this.setState({
        FirstNameError,
        LastNameError,
        PhoneNumberError,
        DateOfBirthError,
        StreetAddressError,
        StreetAddress2Error,
        CityError,
        StateError,
        ZipCodeError,
        CountryError,
        HomePhoneNumberError,
        Hepetitis_MMR_B_vaccError,
        Significant_Medical_HistoryError,
        List_any_medication_taken_regularlyError,
        AllergiesError,
        DoYouHaveMedicalInsuranceError,
        NameOfInsuranceCompanyError,
        InsuranceCompanyAddressError,
        InsuranceCompanyAddress2Error,
        InsuranceCompanyCityError,
        InsuranceCompanyAddressStateError,
        InsuranceCompanyZipcodeError,
        InsuranceCompanyCountryError,
        PolicyNumberError,
        PolicyExpiryDateError,
      });
      return false;
    }
    return true;
  };

  onSubmit = (e) => {
    e.preventDefault();
    const isValid = this.validate();
    if (isValid) {
      let existingPatientData = localStorage.getItem("patient_personal_info");
      existingPatientData = JSON.parse(existingPatientData);
      existingPatientData.existingPatientData.push(this.state);
      localStorage.setItem(
        "patient_personal_info",
        JSON.stringify(existingPatientData)
      );

      toast.info("Updating Info....!", {
        autoClose: 2000,
      });
      this.setState(initialState);
    }
  };
  render() {
    return (
      <>
        <div className={detailstyles.backgroundpd}>
          <Header name="Personal information" />
          <Backicon
            onClick={() => this.props.history.goBack()}
            style={{
              background:
                "linear-gradient(60deg, rgba(2, 12, 29, 0.644) 0%, rgba(67, 184, 192, 0.548) 98%)",
              color: "white",
              position: "fixed",
            }}
          />
          <div className={basestyles.InputWidth}>
            <form>
              <label className={detailstyles.ptname}>Name</label>
              <Input
                type="text"
                placeholder="First Name"
                name="FirstName"
                value={this.state.FirstName}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.FirstNameError ? (
                <div className={detailstyles.error}>
                  {this.state.FirstNameError}
                </div>
              ) : null}
              <Input
                type="text"
                placeholder="Last Name"
                name="LastName"
                value={this.state.LastName}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.LastNameError ? (
                <div className={detailstyles.error}>
                  {this.state.LastNameError}
                </div>
              ) : null}

              <label for="phone" className={detailstyles.ptnumber}>
                Phone Number
              </label>
              <Input
                type="tel"
                id="phone"
                placeholder="Number"
                name="PhoneNumber"
                value={this.state.PhoneNumber}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.PhoneNumberError ? (
                <div className={detailstyles.error}>
                  {this.state.PhoneNumberError}
                </div>
              ) : null}

              <label className={detailstyles.ptbirthday}>Birthday</label>
              <Input
                type="date"
                placeholder="Date / Month / Year"
                name="DateOfBirth"
                value={this.state.DateOfBirth}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.DateOfBirthError ? (
                <div className={detailstyles.error}>
                  {this.state.DateOfBirthError}
                </div>
              ) : null}

              <label className={detailstyles.ptaddress}>Address</label>
              <Input
                type="text"
                placeholder="Street address"
                name="StreetAddress"
                value={this.state.streetAddress}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.StreetAddressError ? (
                <div className={detailstyles.error}>
                  {this.state.StreetAddressError}
                </div>
              ) : null}
              <Input
                type="text"
                placeholder="Street address Line 2 "
                name="StreetAddress2"
                value={this.state.streetAddress2}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.StreetAddress2Error ? (
                <div className={detailstyles.error}>
                  {this.state.StreetAddress2Error}
                </div>
              ) : null}
              <Input
                type="text"
                placeholder="City "
                name="City"
                value={this.state.City}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.CityError ? (
                <div className={detailstyles.error}>{this.state.CityError}</div>
              ) : null}
              <Input
                type="text"
                placeholder="State / Province "
                name="State"
                value={this.state.State}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.StateError ? (
                <div className={detailstyles.error}>
                  {this.state.StateError}
                </div>
              ) : null}
              <Input
                type="Tel"
                placeholder="Postal / Zip Code "
                name="ZipCode"
                value={this.state.ZipCode}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.ZipCodeError ? (
                <div className={detailstyles.error}>
                  {this.state.ZipCodeError}
                </div>
              ) : null}
              <Input
                type="text"
                placeholder="Select Country "
                name="Country"
                value={this.state.Country}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.CountryError ? (
                <div className={detailstyles.error}>
                  {this.state.CountryError}
                </div>
              ) : null}

              <label className={detailstyles.pthomephone}>
                Home Phone Number
              </label>
              <Input
                type="Tel"
                placeholder="Phone Number "
                name="HomePhoneNumber"
                value={this.state.HomePhoneNumber}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.HomePhoneNumberError ? (
                <div className={detailstyles.error}>
                  {this.state.HomePhoneNumberError}
                </div>
              ) : null}
              <h2 className={detailstyles.medichistoryheading}>
                General Medical History
              </h2>
              <label className={detailstyles.medichistory}>
                Have you had the Hepatitis,MMR, B-vaccination?{" "}
              </label>
              <div className={detailstyles.ptYesNo}>
                <>
                  <input
                    type="radio"
                    name="Hepetitis_MMR_B_vacc"
                    id="Yes"
                    value="Yes"
                    onChange={(e) => this.changeState(e)}
                    className={detailstyles.yesCheck}
                  />
                  <label>Yes</label>
                </>
                <>
                  <input
                    type="radio"
                    name="Hepetitis_MMR_B_vacc"
                    id="No"
                    value="No"
                    onChange={(e) => this.changeState(e)}
                    className={detailstyles.yesCheck}
                  />
                  <label>No</label>
                </>
              </div>
              {this.state.Hepetitis_MMR_B_vaccError ? (
                <div className={detailstyles.error}>
                  {this.state.Hepetitis_MMR_B_vaccError}
                </div>
              ) : null}
              <label className={detailstyles.immunityinfo}>
                Immunity information <br />
                (please note: this information must be provided prior to
                employment or you will not be allowed to work):
              </label>
              <label className={detailstyles.signhistory}>
                Significant Medical History (surgery, injuries, serious
                illness):
              </label>
              <Textarea
                type="text"
                name="Significant_Medical_History"
                value={this.state.Significant_Medical_History}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.Significant_Medical_HistoryError ? (
                <div className={detailstyles.error}>
                  {this.state.Significant_Medical_HistoryError}
                </div>
              ) : null}

              <label className={detailstyles.medicationtaken}>
                List any medication taken regularly:
              </label>
              <Textarea
                type="text"
                name="List_any_medication_taken_regularly"
                value={this.state.List_any_medication_taken_regularly}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.List_any_medication_taken_regularlyError ? (
                <div className={detailstyles.error}>
                  {this.state.List_any_medication_taken_regularlyError}
                </div>
              ) : null}

              <label className={detailstyles.allergies}>
                List any allergies:
              </label>
              <Textarea
                type="text"
                name="Allergies"
                value={this.state.Allergies}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.AllergiesError ? (
                <div className={detailstyles.error}>
                  {this.state.AllergiesError}
                </div>
              ) : null}
              <h2 className={detailstyles.medichistoryheading}>
                Medical Insurance Details
              </h2>
              <label className={detailstyles.medichistory}>
                Do you have medical insurance? *
              </label>
              <div className={detailstyles.ptYesNo}>
                <>
                  <input
                    type="radio"
                    name="DoYouHaveMedicalInsurance"
                    id="Yes"
                    value="Yes"
                    onChange={(e) => this.changeState(e)}
                    className={detailstyles.yesCheck}
                  />
                  <label>Yes</label>
                </>
                <>
                  <input
                    type="radio"
                    name="DoYouHaveMedicalInsurance"
                    id="No"
                    value="No"
                    onChange={(e) => this.changeState(e)}
                    className={detailstyles.yesCheck}
                  />
                  <label>No</label>
                </>
              </div>
              {this.state.DoYouHaveMedicalInsuranceError ? (
                <div className={detailstyles.error}>
                  {this.state.DoYouHaveMedicalInsuranceError}
                </div>
              ) : null}
              <label className={detailstyles.insuancecomp}>
                Name of Insurance Company:
              </label>
              <Input
                type="text"
                placeholder="Company name"
                name="NameOfInsuranceCompany"
                value={this.state.NameOfInsuranceCompany}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.NameOfInsuranceCompanyError ? (
                <div className={detailstyles.error}>
                  {this.state.NameOfInsuranceCompanyError}
                </div>
              ) : null}

              <label className={detailstyles.addressdetails}>
                Street Address LinState / Province
              </label>
              <Input
                type="text"
                placeholder="Street Address"
                name="InsuranceCompanyAddress"
                value={this.state.InsuranceCompanyAddress}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.InsuranceCompanyAddressError ? (
                <div className={detailstyles.error}>
                  {this.state.InsuranceCompanyAddressError}
                </div>
              ) : null}
              <Input
                type="text"
                placeholder="Street Address Line 2"
                name="InsuranceCompanyAddress2"
                value={this.state.InsuranceCompanyAddress2}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.InsuranceCompanyAddress2Error ? (
                <div className={detailstyles.error}>
                  {this.state.InsuranceCompanyAddress2Error}
                </div>
              ) : null}
              <Input
                type="text"
                placeholder="City "
                name="InsuranceCompanyCity"
                value={this.state.InsuranceCompanyCity}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.InsuranceCompanyCityError ? (
                <div className={detailstyles.error}>
                  {this.state.InsuranceCompanyCityError}
                </div>
              ) : null}
              <Input
                type="text"
                placeholder="State / Province "
                name="InsuranceCompanyAddressState"
                value={this.state.InsuranceCompanyAddressState}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.InsuranceCompanyAddressStateError ? (
                <div className={detailstyles.error}>
                  {this.state.InsuranceCompanyAddressStateError}
                </div>
              ) : null}
              <Input
                type="text"
                placeholder="Postal / Zip Code "
                name="InsuranceCompanyZipcode"
                value={this.state.InsuranceCompanyZipcode}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.InsuranceCompanyZipcodeError ? (
                <div className={detailstyles.error}>
                  {this.state.InsuranceCompanyZipcodeError}
                </div>
              ) : null}
              <Input
                type="text"
                placeholder="Select Country "
                name="InsuranceCompanyCountry"
                value={this.state.InsuranceCompanyCountry}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.InsuranceCompanyCountryError ? (
                <div className={detailstyles.error}>
                  {this.state.InsuranceCompanyCountryError}
                </div>
              ) : null}
              <label className={detailstyles.policyno}>Policy Number : </label>
              <Input
                type="Tel"
                placeholder="Number"
                name="PolicyNumber"
                value={this.state.PolicyNumber}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.PolicyNumberError ? (
                <div className={detailstyles.error}>
                  {this.state.PolicyNumberError}
                </div>
              ) : null}

              <label className={detailstyles.expiry}>Expiry Date:</label>
              <Input
                type="date"
                placeholder="Date / Month / Year"
                name="PolicyExpiryDate"
                value={this.state.PolicyExpiryDate}
                onChange={(e) => this.changeState(e)}
              />
              {this.state.PolicyExpiryDateError ? (
                <div className={detailstyles.error}>
                  {this.state.PolicyExpiryDateError}
                </div>
              ) : null}

              <Button
                onClick={(e) => this.onSubmit(e)}
                buttonName="Submit"
                style={{
                  color: "white",
                  margin: "20px 15px 30px",
                  padding: "10px 10px",
                  width: "90%",
                  maxWidth: "500px",
                }}
              ></Button>
            </form>
          </div>
        </div>
        <ToastContainer />
      </>
    );
  }
}

export default PatientDetails;
